import { type GetServerSideProps } from 'next';
import { z as schema } from 'zod';

import { FaqChatbotTemplate } from '../../templates';
import { withEnhancedPageHandler } from '../../middlewares/withEnhancedPageHandler';

const Chatbot = (props) => <FaqChatbotTemplate {...props} />;

const getServerSidePropsHandler: GetServerSideProps = async ({ query }) => {
  const chatbotSchema = schema.object({
    token: schema.string().optional(),
    eusou: schema
      .string()
      .regex(/Profissional|Cliente/i)
      .optional(),
    assunto: schema.string().optional(),
    telefone: schema.string().optional(),
    email: schema.string().optional(),
    nome_usuario: schema.string().optional(),
    cpfcnpj: schema
      .string()
      .regex(/^\d*$/)
      .or(schema.string().regex(/null/))
      .optional(),
  });

  const parsedSchema = chatbotSchema.safeParse(query);

  if (parsedSchema.success === false) {
    return {
      redirect: {
        destination: '/nao-encontrado',
        permanent: false,
      },
    };
  }

  let chatbot: any = {
    baseUrl: process.env.NEXT_PUBLIC_CHATBOT_BASE_URL,
    id: process.env.NEXT_PUBLIC_CHATBOT_ID,
  };

  if (parsedSchema.data.eusou === 'Cliente') {
    chatbot = {
      ...chatbot,
      url: process.env.NEXT_PUBLIC_CHATBOT_CLI_URL,
      scriptUrl: process.env.NEXT_PUBLIC_CHATBOT_CLI_SCRIPT_URL,
      type: 'Chat_Clientes',
    };
  } else {
    chatbot = {
      ...chatbot,
      url: process.env.NEXT_PUBLIC_CHATBOT_PRO_URL,
      scriptUrl: process.env.NEXT_PUBLIC_CHATBOT_PRO_SCRIPT_URL,
      type: 'Chat_Profissionais',
    };
  }

  return {
    props: {
      meta: {
        title: 'Central de Ajuda - Chat | GetNinjas',
        description:
          'Tem alguma dúvida sobre como funciona o serviço do GetNinjas? Acesse nosso Chat e tire todas as suas dúvidas em um único lugar!',
      },
      chatbot,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default Chatbot;
